import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import tokenApi from "../../services/deployTokenApi";
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';

export const getOwnedTokens = createAsyncThunk("token/getPurchasedTokens", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await tokenApi.getPurchasedTokens(data);
        if (response.status === 0) {   
            dispatch(setMatchStatus({
                matchDetails: { ...response?.data?.matchDetails, matchId: data?.matchId }
            }));      
            return response?.data?.tokens;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const deployToken = createAsyncThunk("token/deployToken", async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await tokenApi.deployTokens(data);
        if (response.status === 0) { 
            dispatch(showSuccessSnackbar({ title: response?.data?.message }));          
            return response?.data;
        } else {
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        console.log(error);
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});


// export const getTeamPlayers = createAsyncThunk("token/getTeamPlayers", async (data, { rejectWithValue, dispatch }) => {
//     try {
//         const response = await tokenApi.getTeamPlayers(data);
//         if (response.status === 0) {
            
//             return response?.data?.message;
//         } else {
//             dispatch(showErrorSnackbar({ title: response?.message }));
//             return rejectWithValue(response?.message); // Reject with error message
//         }
//     } catch (error) {
//         console.log(error);
//         dispatch(showErrorSnackbar({ title: error?.message }));
//         return rejectWithValue(error.message); // Handle unexpected errors
//     }
// });


// export const getActions = createAsyncThunk("token/getActions", async (data, { rejectWithValue, dispatch }) => {
//     try {
//         const response = await tokenApi.getActions(data);
//         if (response.status === 0) {
            
//             return response?.data?.message;
//         } else {
//             dispatch(showErrorSnackbar({ title: response?.message }));
//             return rejectWithValue(response?.message); // Reject with error message
//         }
//     } catch (error) {
//         console.log(error);
//         dispatch(showErrorSnackbar({ title: error?.message }));
//         return rejectWithValue(error.message); // Handle unexpected errors
//     }
// });
const deployTokenSlice= createSlice({
    name: "token",
    initialState: {
        tokens: [],
        tokenLoading: true,
        deoployTokenApiData: null,
        deployTokenLoading: false,
        error: null,
        purchasedTokensDetails: null,
    },
    reducers: {
        setMatchStatus: (state, action) => {
            state.purchasedTokensDetails = action.payload; // Update matchStatus in matchDetails
        },
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, getOwnedTokens, "tokens", "error", "tokenLoading");
        handleAsyncThunk(builder, deployToken, "deoployTokenApiData", "error", "deployTokenLoading");
    },
});

export const { setMatchStatus } = deployTokenSlice.actions

export default deployTokenSlice.reducer;